/* eslint-disable */
import * as Dialog from '@radix-ui/react-dialog';
import clsx from 'clsx';
import { Button } from 'components/button';
import Card from 'components/card';
import { useState } from 'react';
import { MdClose } from 'react-icons/md';
import { formatAddress } from 'utils/address';
import { BlockConfirmDialog } from 'views/admin/Users/components/BlockConfirmDialog';
import { IDepositExtended } from 'views/types/typeTransaction';
import { ReadPermissionGate } from 'components/PermissionGate';
import { PERMISSION_RESOURCES } from 'constants/permissions';

import TransactionDetails from '../TransactionDetails/TransactionDetails';

interface IProps {
  transaction: IDepositExtended;
  refetchDeposits: () => Promise<unknown>;
  isOpen?: boolean;
  onClose?: () => void;
  isInternal: boolean;
  isBlocked?: boolean;
  isWithdraw: boolean;
  isSwap: boolean;
  isCardTransaction?: boolean;
  isReferralTransaction?: boolean;
}

export const TransactionDialog: React.FC<IProps> = ({
  transaction,
  refetchDeposits,
  isOpen,
  onClose,
  isInternal,
  isBlocked,
  isWithdraw,
  isSwap,
  isCardTransaction,
  isReferralTransaction,
}) => {
  return (
    <ReadPermissionGate resource={PERMISSION_RESOURCES.TRANSACTION_INNER_PAGE}>
      <Dialog.Root
        open={isOpen}
        onOpenChange={isOpen => !isOpen && onClose()}
        modal
      >
        <Dialog.Portal>
          <Dialog.Overlay className="data-[state=open]:animate-overlayShow fixed inset-0 z-50 bg-gray-800 bg-opacity-50" />
          <Dialog.Content
            onInteractOutside={e => {
              if ((e.target as HTMLElement).closest('.chakra-toast')) {
                e.preventDefault();
              }
            }}
            className="data-[state=open]:animate-contentShow fixed left-[50%] top-[50%] z-[60] max-h-[85vh] h-[85vh] w-[90vw] max-w-[90vw] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-white p-[25px] shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none dark:bg-gray-800 dark:text-white"
          >
            <Dialog.Title className="sm-max:w-full sm-max:flex-col-reverse flex justify-between items-center relative text-center text-mauve12 mb-10 text-[17px] font-medium">
              <div className="flex"></div>

              <div className="md-max:mb-3 md-max:flex-col md-max:w-full flex justify-between w-[69%] md-max:mr-0 mr-3">
                <span>Transaction {formatAddress(transaction.id)} details</span>
              </div>
            </Dialog.Title>

            <Card
              extra={
                'w-full h-[80%] md:h-[90%] lg-max:max-h-[100%] overflow-y-auto sm:overflow-auto px-6 pb-6'
              }
            >
              <TransactionDetails
                transaction={transaction}
                showActions={isBlocked}
                isInternal={isInternal}
                isBlocked={isBlocked}
                isWithdraw={isWithdraw}
                isSwap={isSwap}
                isCardTransaction={isCardTransaction}
                isReferralTransaction={isReferralTransaction}
                onRefetch={refetchDeposits}
                onClose={onClose}
              />
            </Card>

            <Dialog.Close asChild>
              <button
                type="button"
                className="text-violet11 hover:bg-violet4 focus:shadow-violet7 absolute right-[10px] top-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
                aria-label="Close"
              >
                <MdClose />
              </button>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </ReadPermissionGate>
  );
};
